import React from 'react';
import Modal2 from 'components/commons/modal/Modal2';

export const TagListModal = ({
  hide,
  isShow,
}: {
  isShow: boolean;
  hide: () => void;
}) => {
  type TagItems = {
    name: string;
    text: string;
  };

  const profileTagItems = [
    {
      name: '年代',
      text: '自分と近い年代のペルソナと比較',
    },
    {
      name: '投資歴',
      text: '自分と近い投資歴のペルソナと比較',
    },
    {
      name: '年収',
      text: '自分と近い年収のペルソナと比較',
    },
  ] as TagItems[];

  const accountTagItems = [
    {
      name: 'NISA',
      text: '保有銘柄の半分以上をNISA口座で運用',
    },
    {
      name: '確定拠出年金',
      text: '保有銘柄の半分以上を確定拠出年金口座で運用',
    },
  ] as TagItems[];

  const investmentProductsTagItems = [
    {
      name: '国内株式30％以上',
      text:
        '資産総額のうち30％以上の金額を「国内株式」に投資している商品で保有している。',
    },
    {
      name: '先進国株式30％以上',
      text: (
        <>
          資産総額のうち30％以上の金額を「先進国<sup>※</sup>
          株式」に投資している商品で保有している。
        </>
      ),
    },
    {
      name: '現金30％以上',
      text: '資産総額のうち30％以上の金額を現金で保有している。',
    },
  ] as TagItems[];

  const tagColor = {
    profile: 'bg-bluegray-100 border-bluegray-300',
    account: 'bg-cyan-50 border-blue-250',
    investmentProducts: 'bg-indigo-50 border-indigo-300',
  };

  const tagList = (title: string, items: TagItems[], color: string) => {
    return (
      <>
        <div className="mt-4 text-sm font-bold">{title}</div>
        {items.map((item, key) => {
          return (
            <div className="flex flex-col mt-2" key={key}>
              <div className="flex flex-row items-center">
                <div className={`py-1 px-2 text-xs border ${color} rounded-md`}>
                  {item.name}
                </div>
              </div>
              <div className="pt-2 pb-3 text-sm border-b border-bluegray-300">
                {item.text}
              </div>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <>
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto">
          <div className="flex flex-col">
            <div className="flex flex-row">
              <div className="text-base font-bold">タグの表示条件</div>
              <div
                className="icon-close ml-auto text-gray-500 cursor-pointer"
                onClick={hide}
              />
            </div>
            <div className="mt-2 text-sm">
              これらのタグはあなたの資産・運用状況から自動で付けられます。編集することはできません。
            </div>

            {tagList('プロフィール', profileTagItems, tagColor.profile)}
            {tagList('口座の種類', accountTagItems, tagColor.account)}
            {tagList(
              '保有資産の種類',
              investmentProductsTagItems,
              tagColor.investmentProducts
            )}

            <div className="mt-2 text-xs">
              ※日本を除いた北米地域、欧州地域、アジア太平洋地域の先進国が対象です。
            </div>
            <button className={`mt-4 p-2 text-center text-sm`} onClick={hide}>
              閉じる
            </button>
          </div>
        </div>
      </Modal2>
    </>
  );
};
